import React from "react";
import './index.css';
import { FaLocationDot } from "react-icons/fa6";
import { FaPlayCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { secureUrl } from "../../../../../../../../utils/sortArray/secureUrl";

const MatchCardGrid = ({match})=>{
    const navigate = useNavigate();
    const redirectToPlayer = (match)=>{
        navigate(`/player/match/${match?._id}?urlGame=${match?.urlGame}`)

    }
    const renderTeamInfo = (img, name)=>{
        return(
                <div className="match-card-grid-team-container" >
                <div className="match-card-grid-team-subcontainer" >
                 <img  height={25} width={25} src={secureUrl(img)} />
                  <p >{name}</p>
                   </div>
                </div>
        )
    }

    const renderTimeInfoMatch = (match)=>{
       if(match?.tiempo) return (<div className="match-card-grid-time-label" style={{backgroundColor: match?.tiempo === 'finalizo' ? 'red' : ''}}>{match?.tiempo}</div>)

    }
    const renderWatchInfo = (match)=>{
        if(match?.urlGame && match?.torneo?.activoPlayer) return(
         <div onClick={()=> redirectToPlayer(match)} className="match-card-grid-watch-content" >
           <FaPlayCircle style={{height:'15px', width:'15px', marginRight:'5px', color:'white'}} />
            <p>{match?.tiempo === 'finalizo' ? 'Ver Repetición' : 'ver partido'}</p>                                          
        </div>)
    }

    return(
        <div className="match-card-grid">
                                    <div className="match-card-grid-header" >
                                        <p>{match?.jornada}</p>
                                        <div className="match-card-grid-header-tournament" >
                                            <img  src={secureUrl(match?.torneo?.imgPicture)} />
                                            <p >{match?.torneo?.name}</p>
                                        </div>
                                    </div>
                                    <div className="match-card-grid-body" >
                                        <div className="match-card-grid-body-teams">
                                            {renderTeamInfo(match?.equipoLocal?.pictureTeam, match?.equipoLocal?.name )}
                                            {renderTeamInfo(match?.equipoVisitante?.pictureTeam, match?.equipoVisitante?.name)}
                                        </div>
                                        <div className="match-card-grid-body-result">
                                            <h4 >{match?.resultado?.split('-')?.[0]}</h4>
        
                                             <h4 >{match?.resultado?.split('-')?.[1]}</h4>
        
                                        </div>
                                        <div className="match-card-grid-body-extra-info">
                                            {renderTimeInfoMatch(match)}
                                            {renderWatchInfo(match)}
                                        </div>
                                    </div>
                                    <div className="match-card-grid-footer" >
                                        <p>{match?.horario}</p>
                                        <div>
                                            <FaLocationDot style={{color:'lightgrey'}} />
                                            <a target="_blank" href={match?.ubicacion} >{match?.estadio}</a>
                                        </div>
                                    </div>
                                </div>
)}

export default MatchCardGrid